<template>
  <div class="col-12">
    <div class="row res-container">
      <div class="col-12">
        <div class="row">
          <div class="mask" v-for="(mask, i) in res.masks" v-bind:key="i">
            <div class="col-8-sm mask-name">{{mask.name}}</div>
            <div class="col-1-sm mask-size">{{mask.size}}</div>
            <div class="col-1-sm mask-type">
              <span v-if="mask.type == 'string'">
                <font-awesome-icon :icon="['fa', 'signature']" />
              </span>
              <span v-else>
                <font-awesome-icon :icon="['fa', 'head-side-mask']" />
              </span>
            </div>
            <div class="col-2-sm mask-status"
              @click="markComplete(i)"
              >
              <span v-if="mask.completed">
                <font-awesome-icon :icon="['fa', 'check-circle']" />
              </span>
              <span v-else>
                <font-awesome-icon :icon="['fa', 'circle-notch']" />
              </span>
            </div>
          </div>
        </div>
        <div class="row res-header">
          <div class="col-10-sm total-label">
            Total:
          </div>
          <div class="col-2-sm total">
            {{res.masks.length}}
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {reservationsRef} from '../../../firebase/firebaseConfig.js'
export default {
  name: 'ReservationCard',
  props: {
    res: Object,
    i: Number
  },
  mounted() {
  },
  data: function (){
    return {
      reservations: [],
      show: {},
      summary: {},
      newPaymentAmount: null,
      newEventDate: this.today()
    }
  },
  methods: {
    today() {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      if (month <= 9) {
        month = '0' + month;
      }
      let day = new Date().getDate()
      return [year, month, day].join('-')
    },
    toggleTab(tab, i) {
      this.$parent.toggleTab(tab, i)
    },
    getTime(time) {
      if (time && time.seconds) {
        let submitted = new Date(time.seconds*1000)
        return submitted.toLocaleDateString("en-US")
      } else {
        return null
      }
    },
    masksComplete(masks) {
      let complete = true
      masks.forEach(mask=>{
        if (!mask.completed) {
          complete = false
        }
      })
      return complete
    },
    sendCompleteEmail(res) {
      console.log('sending...')
      this.$store.commit('sendCompleteEmail', res)
    },
    formatEmailComplete(d) {
      if (d) {
        let day = new Date(d.seconds * 1000).toISOString().slice(5,10)
        let time = new Date(d.seconds * 1000).toLocaleTimeString().slice(0,5) + ' ' + new Date(d.seconds * 1000).toLocaleTimeString().slice(9,11)
        return day + ' / ' + time
      }
    },
    saveDelivery(method, id) {
      let vm = this

      let path = {
        delivery: {
          date: vm.newEventDate,
          method: method
        },
        updated: new Date(),
      }
      vm.reservations = []

      reservationsRef.doc(id).update(path).then(function() {
        console.log('signed, sealed, delivered');
        // setTimeout(function(){
        //   let elmnt = document.getElementById(id)
        //   elmnt.scrollIntoView();
        // }, 1000);

      }).catch(function(error) {
        console.log('error', error)
      })
    },
    savePayment(method, id) {
      let vm = this

      let path = {
        payment: {
          amount: vm.newPaymentAmount,
          date: vm.newEventDate,
          method: method
        },
        updated: new Date(),
      }
      vm.reservations = []

      reservationsRef.doc(id).update(path).then(function() {
        console.log('caching $$$');
        // setTimeout(function(){
        //   let elmnt = document.getElementById(id)
        //   elmnt.scrollIntoView();
        // }, 1000);

      }).catch(function(error) {
        console.log('error', error)
      })
    },
    markComplete(i) {
      if (this.res.masks[i].completed) {
        this.res.masks[i].completed = null;
      } else {
        this.res.masks[i].completed = new Date();
      }
      let updatedMasks = [...this.res.masks]
      let path = {
        masks: updatedMasks,
        updated: new Date(),
      }
      reservationsRef.doc(this.res.uuid).update(path).then(function() {
      }).catch(function(error) {
        console.log('error', error)
      })
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.res-container {
  .mask-size, .mask-type, .mask-status {
    text-align: center;
  }
  .total-label {
    text-align: right;
  }
  .total {
    text-align: center;
  }
}
</style>
